import { observer } from 'mobx-react';
import React, { SyntheticEvent, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { FormattedMessage } from 'react-intl';
import SlidingPanel from 'react-sliding-side-panel';
import 'react-sliding-side-panel/lib/index.css';
import noMessageIcon from '../../assets/Images/no-factory.png';
import { ModuleType } from '../../constants/enums/module-type-enum';
import userSettingEnum from '../../constants/enums/user-setting-enum';
import { GridRemoteConstant } from '../../constants/grid-constant';
import { useStore } from '../../contexts/store-provider';
import {
  FactoryDefaultSortColumnOrder,
  FactoryFilterInitialState,
} from '../../core/initialState/filter-initial-state';
import {
  isOperationPermittedRoleBase,
  showIconsRoleBase,
} from '../../helpers/action-permission-helper';
import IPageInfo, {
  IActionFormatter,
  IPageLimitInfo,
} from '../../models/ICommon';
import IDefaultColumSortOrder from '../../models/IDefaultColumSortOrder';
import { IFactoryFilter } from '../../models/IFactoryFilter';
import { IFactoryList } from '../../models/response/IFactoryResponse';
import LoaderButton from '../../shared-components/button/loader-button';
import FormLoader from '../../shared-components/FormLoader/FormLoader';
import Grid from '../../shared-components/Grid/Grid';
import { CustomActionFormatter } from '../../shared-components/Grid/GridFormatter';
import Pagination from '../../shared-components/Grid/Pagination';
import FilterPopupHOC from '../../shared-components/hoc/filter-popup-hoc/filter-popup-hoc';
import DeletePopup from '../../shared-components/popup/delete/delete-popup';
import DeletePopupHOC from '../../shared-components/popup/delete/delete-popup-hoc';
import {
  CloseSidePanelIcon,
  DeleteIcon,
  EditIcon,
  PlusIcon,
  RefreshIcon,
} from '../../shared-components/svgs/svgs';
import { formatMessage } from '../../translations/format-message';
import AddUpdateFactory from '../factory/components/add-edit-factory';
import FilterComponent from './components/filter';
import FactoryDetails from './factory-details';
import './factory.css';
import AddFactoryPopupHOC from './hoc/AddFactoryPopupHOC';

const Factory = (props: any) => {
  const { factoryStore, preferencesStore } = useStore();
  const {
    GetFactoryListService,
    DeleteFactoryService,
    deleteFactoryState,
    addUpdateFactoryState,
    factoryDataList,
    reset,
    resetGetFactoryDetail,
    getAllFactoryState,
    allFactorylist,
    getFactoryByIdServiceState,
  } = factoryStore;

  let lang: string;
  const {
    userSetting,
    setUserSetting,
    language,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;
  const [selectedId, setSelectedId] = useState<number>(0);
  const [isFilterApplied, setIsFilterApplied] = useState<boolean>(false);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [openPanel, setOpenPanel] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const allFactorysList: Array<IFactoryList> = allFactorylist;
  const pageLimitOptions: Array<number> = [10, 20, 50, 100];
  const [isFilterCleared, setIsFilterCleared] = useState(true);
  const [filterObj, setFilterObj] = useState<IFactoryFilter>(
    FactoryFilterInitialState
  );
  const [columSortOrder, setColumnSortOrder] = useState<IDefaultColumSortOrder>(
    FactoryDefaultSortColumnOrder
  );
  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });
  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const filterHandler = (object: IFactoryFilter) => {
    const filter = createQueryString({
      ...object,
      Column: getFieldName(columSortOrder.dataField),
      Order: columSortOrder.order,
    });
    getFactoryListServiceHandler(filter);
    setFilterObj({
      ...object,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    });
    props.filterPopupToggleHandler();
    closePanelhandler();
    setIsFilterCleared(false);
  };

  const filterParams = (obj: IFactoryFilter, isfilterCleard: boolean) => {
    const filter = createQueryString({
      ...obj,
      Column: getFieldName(columSortOrder.dataField),
      Order: columSortOrder.order,
    });

    if (isfilterCleard) {
      setFilterObj({ ...obj });
      getFactoryListServiceHandler(filter);
      closePanelhandler();
      setIsFilterCleared(true);
    } else {
      setFilterObj({ ...obj });
    }
    props.filterPopupToggleHandler();
  };

  useEffect(() => {
      const filter = createQueryString({
        ...filterObj,
        Column: getFieldName(columSortOrder.dataField),
        Order: columSortOrder.order,
      });
      getFactoryListServiceHandler(filter);
    }, [columSortOrder]);

  const createQueryString = (filter: IFactoryFilter): string => {
    return Object.entries(filter)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('#');
  };

  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  function getFieldName(field: string): string {
    switch (field) {
      case 'FactoryName':
        return 'factory_name';
      case 'FactoryType':
        return 'factory_type';
      default:
        return 'factory_name';
    }
  }

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    pages = props.data && Math.ceil(props.data.length / evt.target.value);
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.UserLimitConfig, parseInt(evt.target.value));
  };

  const handleTableChange = (type: any, newState: any) => {
    setColumnSortOrder({
      ...columSortOrder,
      dataField: newState.sortField,
      order: newState.sortOrder,
    });
    const filter = createQueryString({
      ...filterObj,
      Column: getFieldName(newState.sortField),
      Order: newState.sortOrder,
    });

    getFactoryListServiceHandler(filter);
  };

  /**
   * This function calls the "getAllGroup" store funtion that get configuration list from API
   */
  const getFactoryListServiceHandler = (filterQuery?: string, isFilter = false) => {
    if (!filterQuery) {
      filterQuery = createQueryString({ ...filterObj });
    }
    if(!isFilter){
      GetFactoryListService(
        pageInfo.currentPage,
        pageLimitInfo.pageLimit,
        encodeURIComponent(filterQuery)
      );
    } else{
      GetFactoryListService(
        1,
        pageLimitInfo.pageLimit,
        encodeURIComponent(filterQuery)
      );
    }
  };

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "language" of the useEffect changed.
   */
  useEffect(() => {
    if (islanguageChanged) {
      getFactoryListServiceHandler();
      updateLanguageChangedFlag();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [islanguageChanged]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "GroupList" of the useEffect changed.
   */
  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      currentPage:factoryDataList?.PagingDetails.CurrentPage,
      totalPages: factoryDataList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setDisablePagination(false);
  }, [factoryDataList]);

  // useEffect(() => {
  //   setPageInfo({
  //     ...pageInfo,
  //     totalPages: factoryDataList?.PagingDetails?.TotalPages,
  //     isPagerChange: false,
  //   });
  //   setDisablePagination(false);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [factoryDataList]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "pageInfo.currentPage" of the useEffect changed.
   */
  useEffect(() => {
    if (pageInfo.isPagerChange) {
      const filter = createQueryString({
        ...filterObj,
        Column: getFieldName(columSortOrder.dataField),
        Order: columSortOrder.order,
      });
      getFactoryListServiceHandler(filter);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  /**
   * This function shows the add user pop up from where we can add new user and update existing user. we use id to identify
   * that we are adding or updating user.
   * "Id == -1" : we are adding new user
   * "Id != -1" : means we are updating existing user
   */
  const openAddFactoryHandler = (
    row: { TenantId: number },
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    closePanelhandler();
    resetGetFactoryDetail();
    setSelectedId(row.TenantId);
    props.addFactoryToggleHandler();
  };

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "pageLimitInfo.pageLimit" of the useEffect changed.
   */
  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      const filter = createQueryString({
        ...filterObj,
        Column: getFieldName(columSortOrder.dataField),
        Order: columSortOrder.order,
      });
      getFactoryListServiceHandler(filter);
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageLimitInfo.pageLimit]);

  /**
   * This function deletes the user by providing Id to the Api
   */
  const deleteHandler = () => {
    DeleteFactoryService(selectedId);
  };

  /**
   * This function shows the delete user confirmation popup component and sets the seleted user Id
   */
  const deleteClickHandler = (
    row: { TenantId: number },
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setSelectedId(row.TenantId);
    event.stopPropagation();
    closePanelhandler();
    resetGetFactoryDetail();
    props.deletePopupToggleHandler();
  };

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateGroupstate.success" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateFactoryState.success) {
      getFactoryListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUpdateFactoryState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "deleteFactorySuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (deleteFactoryState.success) {
      toast.success(formatMessage('deleted_success'));
      reset();
      props.deletePopupToggleHandler();
      getFactoryListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteFactoryState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "language" of the useEffect changed.
   */
  useEffect(() => {
    if (language !== lang) {
      getFactoryListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  /**
   * This function provides manual refresh functionality
   */
  const refreshClickHandler = () => {
    getFactoryListServiceHandler();
  };

  function rowClassFormat(row: any, rowIdx: number) {
    let className = '';
    if (selectedRow?.Id && row.Id === selectedRow.Id) {
      className = 'bg-row SelectedRow';
    }
    return className;
  }

  const rowEvents = (e: SyntheticEvent, row: any) => {
    setSelectedRow(row);
    if (
      selectedRow.TenantId === undefined ||
      selectedRow.TenantId !== row.TenantId
    ) {
      setOpenPanel(true);
    } else {
      setOpenPanel(!openPanel);
    }
  };

  const closePanelhandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
    resetGetFactoryDetail();
  };

  const actionIcons: IActionFormatter[] = showIconsRoleBase(
    [
      {
        dataField: 'isEdit',
        handler: openAddFactoryHandler,
        icon: <EditIcon />,
        isDisable: false,
        title: 'edit',
        varient: 'primary',
        action: 'edit',
      },
      {
        dataField: 'isDelete',
        handler: deleteClickHandler,
        icon: <DeleteIcon />,
        isDisable: false,
        title: 'delete',
        varient: 'danger',
        action: 'delete',
      },
    ],
    ModuleType.TenantManagement
  );

  const columns: any = [
    {
      dataField: 'Id',
      text: formatMessage('label_id'),
      hidden: true,
    },
    {
      dataField: 'FactoryName',
      text: formatMessage('factory_name'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'FactoryAddress',
      text: formatMessage('factory_location'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: '',
      formatter: CustomActionFormatter(actionIcons),
      text: formatMessage('actions'),
      classes: 'last-column',
      hidden: actionIcons.length > 0 ? false : true,
    },
  ];

  return (
    <React.Fragment>
      {props.showAddFactoryPopup && (
        <AddUpdateFactory
          id={selectedId}
          modalClosed={props.addFactoryToggleHandler}
        />
      )}
      {props.showDeletePopup && (
        <DeletePopup
          title="delete_factory"
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          message="message_delete_factory_confirm"
          isLoading={deleteFactoryState.inProgress}
        />
      )}
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <div className="page_title_wrap">
              <h1 className="page_title">
                <FormattedMessage id="factory_management" />
              </h1>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <FormattedMessage id="home" />
                </li>
                <li
                  className="breadcrumb-item active"
                  aria-current="page"
                >
                  <FormattedMessage id="factory_management" />
                </li>
              </ol>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="add-list">
              <li>
                <FilterComponent
                  initialValues={filterObj}
                  id={0}
                  submitHandler={filterHandler}
                  filterParmas={filterParams}
                  onModalClosed={props.filterPopupToggleHandler}
                  isFilterCleared={isFilterCleared}
                  isLoading={false}
                  isDisable={false}
                  isFilterApplied={isFilterApplied}
                  setIsFilterApplied={setIsFilterApplied}
                />
              </li>{' '}
              <li title={formatMessage('refresh')}>
                <a
                  data-toggle="modal"
                  className="btn btn-light"
                  onClick={() => refreshClickHandler()}
                >
                  <RefreshIcon />
                </a>
              </li>
              {isOperationPermittedRoleBase(
                ModuleType.TenantManagement,
                'Add'
              ) && (
                <li
                  title={formatMessage('add_factory')}
                  className="mt-1"
                >
                  <a
                    className="btn btn-secondary"
                    data-toggle="modal"
                    onClick={(event: any) =>
                      openAddFactoryHandler({ TenantId: -1 }, event)
                    }
                    data-testid="modalbtn"
                    data-target="#addUser"
                  >
                      <span className='me-1'> <PlusIcon /></span>
                    <FormattedMessage id="add_factory" />
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
      <div className={`${openPanel ? 'panelOpen' : ''}`}>
        <div className="card card-page">
          {(getAllFactoryState.inProgress ||
            getFactoryByIdServiceState.inProgress) && (
            <FormLoader
              loading={
                getAllFactoryState.inProgress ||
                getFactoryByIdServiceState.inProgress
              }
            />
          )}
          {allFactorysList.length > 0 ? (
            <>
              <div>
                <div className="tableDesign row-eq-height tableDevices p-3 changingPanel">
                  <div
                    className="table-responsive"
                    data-testid="table"
                  >
                    {allFactorysList && (
                      <Grid
                        onTableChange={handleTableChange}
                        data={allFactorysList}
                        columns={columns}
                        keyField="FactoryId"
                        loading={false}
                        rowClasses={rowClassFormat}
                        rowEvents={{ onClick: rowEvents }}
                        hover={true}
                        sort={{ ...columSortOrder }}
                        remote={{ ...GridRemoteConstant }}
                      />
                    )}
                  </div>
                </div>
              </div>
              {allFactorysList.length > 0 ? (
                <div className="row no-gutters p-3 pt-0 tableFooter">
                  <div className="col-lg-3 col-md-6 col-sm-6 pt-1">
                    <FormattedMessage id="show" />
                    <select
                      data-testid="pageSelect"
                      className="pageLimit"
                      onChange={onPageLimitChanged}
                      value={pageLimitInfo.pageLimit}
                    >
                      {pageLimitOptions.map((option: any) => (
                        <option
                          key={option}
                          value={option}
                        >
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-9 col-md-6 col-sm-6 d-flex justify-content-sm-end">
                    <Pagination
                      isRefreshPage={false}
                      totalPages={pageInfo.totalPages}
                      pageLimit={pageLimitInfo.pageLimit}
                      onPageChanged={onPageChanged}
                      disablePagination={disablePagination}
                      setIsRefreshPage={setIsRefreshPage}
                      currentPage={pageInfo.currentPage}
                      totalRecords={factoryDataList.PagingDetails.TotalRecords}
                    />
                  </div>
                </div>
              ) : (
                ''
              )}
            </>
          ) : (
            <div className="message">
              <div className="d-flex message-area">
                <div className="no-data-img">
                  <img
                    src={noMessageIcon}
                    alt=""
                    className="no_message"
                  />
                </div>
                <div>
                  <h3 className="fw-bold display-6">
                    {' '}
                    <FormattedMessage id="no_factory" />
                  </h3>
                  <h4 className="mb-3">
                    {formatMessage('no_factory_message')}
                  </h4>
                  {isOperationPermittedRoleBase(
                    ModuleType.TenantManagement,
                    'Add'
                  ) && (
                    <>
                      <a
                    className="btn btn-primary"
                    onClick={(event: any) =>
                      openAddFactoryHandler({ TenantId: -1 }, event)
                    }
                  >
                      <span className='me-1'> <PlusIcon /></span>
                    <FormattedMessage id="add_factory" />
                  </a>
                    </>

                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <SlidingPanel
        type={'right'}
        isOpen={openPanel}
        noBackdrop={false}
        size={100}
      >
        <div className="bg_slide panel">
          <div className="row bb p-2 pl-4 g-0 align-items-center ">
            <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10">
              <h2 className="fw-bold mb-0 mt-1 ms-2 py-2">
                {selectedRow.FactoryName}
              </h2>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 close-icon-detail">
              <span title={formatMessage('close')}>
                <CloseSidePanelIcon closePanelHandler={closePanelhandler} />
              </span>
            </div>
          </div>
          <div className="group_detailsWrapper pb-3">
            <FactoryDetails selectedRowId={selectedRow.TenantId} />
          </div>
        </div>
      </SlidingPanel>
    </React.Fragment>
  );
};

export default FilterPopupHOC(
  DeletePopupHOC(AddFactoryPopupHOC(observer(Factory)))
);
